import { Balance } from '@Types/api/form/leaveRequest/Balance';

import { LeaveRequestFormValues } from './type';

export const initialValuesForm: LeaveRequestFormValues = {
  empNumber: '',
  leaveTypeID: '',
  startDate: '',
  endDate: '',
  totDays: '',
  remarks: '',
  ticketRequired: 0,
  passportRequired: 1,
  telephone: '',
  replacementEmpNo: null,
  replacementEmpName: null,
  replacementEmpDesignation: null,
  document: null,
  isReplacementRequired: false,
};

export const initialBalance: Balance = {
  asOnToday: 0,
  asOnDate: 0,
  leaveThisYear: 0,
  ticketBalance: 0,
  ticketThisYear: 0,
  eligibleTickets: 0,
  annualLeaveThisYear: 0,
  emergencyLeaveThisYear: 0,
  sickLeaveThisYear: 0,
  isReplacementRequired: false,
};
